import { get } from 'lodash'
import AuthForm from './../elements/auth-form'

const { signin_with_google } = get(
	window,
	'hubConnectorVars.texts',
	false
);

const GoogleForm = () => {
	return (
		<AuthForm action={get(window, 'hubConnectorVars.login.google_auth_url', '')}>
			<input type="hidden" name="context" value="connect"/>
			<button className="sui-button dashui-google-login-button" type="submit">
				<span className="sui-icon-google-login" aria-hidden="true"></span>
				{signin_with_google}
			</button>
		</AuthForm>
	)
}

export default GoogleForm
